import React, { useEffect, useState } from 'react';
import { Walker, walkerPosition } from './actors';

export interface VillageNpc {
  id: string;
  name: string;
  x: number;
  y: number;
  width: number;
  height: number;
  imageWidth: number;
  imageHeight: number;
  firstFrame: number;
  stopX: number;
}

// Coordinates use the same 1000 × 600 village space as the walking canvas.
export const VILLAGE_NPCS: VillageNpc[] = [
  { id: 'iruka', name: 'Iruka', x: 202, y: 538, width: 72, height: 112, imageWidth: 190, imageHeight: 190, firstFrame: 43, stopX: 250 },
  { id: 'teuchi', name: 'Teuchi', x: 650, y: 525, width: 50, height: 101, imageWidth: 47, imageHeight: 101, firstFrame: 61, stopX: 600 },
];
export const NPC_STOP_Y = 550;

export function hasArrivedAtNpc(player: Walker, npc: VillageNpc, now: number, rendered: { x: number; y: number }) {
  const position = walkerPosition(player, now);
  return !position.moving && Math.abs(player.targetX - npc.stopX) < 1 && Math.abs(player.targetY - NPC_STOP_Y) < 1 &&
    Math.hypot(rendered.x - npc.stopX, rendered.y - NPC_STOP_Y) < 2;
}

export function VillageNpcSprites() {
  const [frame, setFrame] = useState(0);
  useEffect(() => {
    const timer = window.setInterval(() => setFrame(value => (value + 1) % 6), 140);
    return () => window.clearInterval(timer);
  }, []);
  const base = `${process.env.PUBLIC_URL}/village-back/npcs`;
  return <div className="vb-npcs" aria-hidden="true">
    {VILLAGE_NPCS.map(npc => <React.Fragment key={npc.id}>
      <img className="vb-npc-shadow" src={`${base}/shadow.png`} alt="" style={{ left: `${npc.x / 10}%`, top: `${npc.y / 6}%` }} />
      <div className="vb-npc-sprite" style={{ left: `${npc.x / 10}%`, top: `${npc.y / 6}%`, width: `${npc.imageWidth / 10}%`, height: `${npc.imageHeight / 6}%` }}>
        {Array.from({ length: 6 }, (_, index) => <img key={index} src={`${base}/${npc.id}/${npc.firstFrame + index}.png`} alt="" style={{ opacity: frame === index ? 1 : 0 }} />)}
      </div>
      <span className="vb-npc-name" style={{ left: `${npc.x / 10}%`, top: `${(npc.y - npc.height - 9) / 6}%` }}>{npc.name}</span>
    </React.Fragment>)}
  </div>;
}
